import { FC, useContext, useEffect, useState } from "react";
import { format } from "date-fns";
import { toZonedTime } from 'date-fns-tz';

import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { AddNoteAPIResponseType, CaseNotesProps, CaseNotesType } from "./types";
import { AuthContext } from "src/context/authContext";


const CaseNotes: FC<CaseNotesProps> = ({ caseNotes, setNotes, caseObject }): JSX.Element => {
  const [addCaseNote, setAddNoteCase] = useState<string>("");

  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);
  const {isManufacturer} = useContext(AuthContext);





  const { data: addNoteResponse, error: addNoteError, mutate: addCaseMutate, removeErrorAndData: clearCaseNoteState } =
    useFetch<AddNoteAPIResponseType>(APIEndpoints.ADD_NOTE);

  useEffect(() => {
    if (addNoteResponse || addNoteError) {
      hideLoader();
      if(addNoteResponse){
        if (addNoteResponse.code === 200) {
          const notes: CaseNotesType = {
            created_at: format(toZonedTime(new Date(addNoteResponse.data.created_at), "America/New_York"), "MM/dd/yyyy hh:mm a"),
            id: addNoteResponse.data.id,
            name: addNoteResponse.data.user_fullname,
            description: addNoteResponse.data.description,
            type: addNoteResponse.data?.type ?? "",
          };
          setNotes((prevNotes) => [notes, ...prevNotes])
          showToast([addNoteResponse.message], ToastTypes.SUCCESS);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addNoteResponse, addNoteError]);

  const addNoteFunction = (event: any) => {
    setAddNoteCase(event.target.value);
  }

  const onAddNoteClick = () => {
    if (addNoteResponse || addNoteError) clearCaseNoteState();

    setLoader();
    const note = {
      ref_id: caseObject && caseObject.case_information ? caseObject.case_information.case_id : 0,
      ref_type: "Case",
      description: addCaseNote,
    };
    setAddNoteCase("");
    addCaseMutate(note);
  };

  return (
    <div className="card">
      <div className="card-header bg-success-subtle">
        <h4 className="mb-0 text-black">Case Notes</h4>
      </div>

      <div className="card-body patient-info-details">
        <div className={`container-fluid case-notes-listing ${(typeof(caseNotes) !== 'string')  && (caseNotes as CaseNotesType[]).length > 0 ? 'mb-4' : ''}`}>
          {(typeof(caseNotes) !== 'string') ? 
          (caseNotes as CaseNotesType[]) && (caseNotes as CaseNotesType[]).length > 0 && (caseNotes as CaseNotesType[]).map((item, index) => (
            <div className={`row mb-2 py-1 align-items-center ${index % 2 === 0 ? 'bg-secondary-subtle' : ''}`} key={index}>
              <div className="col-4">
                <p className="mb-0 fs-6 text-start">{item ? item.name || item.user_fullname || "" : ""}</p>
              </div>
              <div className="col-8">
                <p className="mb-0 fs-6">{item ? item.description : ''}</p>
              </div>
              <div className="col-12 text-start pt-1">
                <p className="mb-0 fs-6">{item ? item.created_at: ''}</p>
              </div>
            </div>
          )) 
          : 
          <h3 className="fw-bold">Redacted</h3>
          }
        </div>

        {/* {caseObject && caseObject.case_information && caseObject.case_information.pharmacy === false ? ( */}
         
           {  !isManufacturer && (typeof(caseNotes) !== 'string') && 
            <>
            <div className="input-group flex-nowrap mt-6 h-100">
              <textarea
                onChange={addNoteFunction}
                value={addCaseNote}
                className="form-control"
                placeholder="Type Notes Here"
                rows={4}
                style={{ resize: "none" }}
              />
            </div>

            <button
              onClick={onAddNoteClick}
              disabled={addCaseNote.length === 0 || /^\s*$/.test(addCaseNote)}
              type="button"
              className="btn btn-blue mt-3 w-100"
            >
              Add Note
            </button>
            </>
          }
          
        {/* ) : null} */}
      </div>
    </div>
  );
};

export default CaseNotes;
